import _ from 'lodash';
import moment from 'moment';
import { Action, Dispatch } from 'redux';
import { IAppState } from './reducers';
import {
  searchAssetAccessLogs,
  AssetAccessLogKey,
  IAssetAccessLogHit,
  ILogSearchParams,
} from '../api/vault/searchEngine';

export enum ActionType {
  Toggle = 'AssetPushToCloud.Toggle',
  LoadLogs = 'AssetPushToCloud.LoadLogs',
  ClearLogs = 'AssetPushToCloud.ClearLogs',
  Reset = 'AssetPushToCloud.Reset',
}

export interface IState {
  isOpen: boolean;
  logs: Array<IAssetAccessLogHit>;
}

export interface IAssetPushToCloudAction extends Action<ActionType> {
  payload?: any;
}

const INITIAL_STATE: IState = {
  isOpen: false,
  logs: [],
};

export default (state: IState = INITIAL_STATE, action: IAssetPushToCloudAction) => {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.LoadLogs:
      return {
        ...state,
        logs: action.payload.logs,
      };
    case ActionType.ClearLogs:
      return {
        ...state,
        logs: [],
      };
    case ActionType.Reset:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export const toggleAssetPushToCloud = () => ({
  type: ActionType.Toggle,
});

export const clearLogs = () => ({
  type: ActionType.ClearLogs,
});

export const resetAssetPushToCloud = () => ({
  type: ActionType.Reset,
});

export const queryAssetPushToCloudLogs = (assetId: string, toggleOnComplete: boolean = false) => async (
  dispatch: Dispatch<IAssetPushToCloudAction>,
  getState: () => IAppState,
) => {
  const searchParams: ILogSearchParams = {
    queryString: '',
    filters: [
      [AssetAccessLogKey.AssetId, assetId],
      [AssetAccessLogKey.ActionType, ['ExchangePushToCloud']],
    ],
  };

  try {
    const response = await searchAssetAccessLogs(searchParams);
    const { data: { data: { hits: { hits } } } } = response;

    const logs = _.orderBy<IAssetAccessLogHit>(hits, (hit) => [moment(hit._source.actionDate).unix()], 'desc');

    dispatch({
      payload: {
        logs,
      },
      type: ActionType.LoadLogs,
    });
  } catch (e) {
    console.error(`[QA] Error occurred while querying for asset "${assetId}" logs`, e.toString());
  }

  if (toggleOnComplete) {
    dispatch({
      type: ActionType.Toggle,
    });
  }
};
